import React from "react";
import {
    Button,
    Grid,
    TextField,
    Box,
    alpha
} from "@mui/material";
import { FilterList } from "@mui/icons-material";
import { i18n } from "../../translate/i18n";
import { useTheme } from "@mui/material/styles";

const Filters = ({
    setDateStartTicket,
    setDateEndTicket,
    dateStartTicket,
    dateEndTicket,
    setQueueTicket,
    queueTicket,
    fetchData
}) => {
    const [dateStart, setDateStart] = React.useState(dateStartTicket);
    const [dateEnd, setDateEnd] = React.useState(dateEndTicket);
    const [fetchDataFilter, setFetchDataFilter] = React.useState(false);
    const theme = useTheme();

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} md={5}>
                    <TextField
                        fullWidth
                        name="dateStart"
                        label={i18n.t("dashboard.date.initialDate")}
                        InputLabelProps={{ shrink: true }}
                        type="date"
                        value={dateStart}
                        onChange={(e) => setDateStart(e.target.value)}
                        variant="outlined"
                        size="small"
                        sx={{
                            "& .MuiOutlinedInput-root": { 
                                borderRadius: "12px",
                                backgroundColor: alpha(theme.palette.background.default, 0.5)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={5}>
                    <TextField
                        fullWidth
                        name="dateEnd"
                        label={i18n.t("dashboard.date.finalDate")}
                        InputLabelProps={{ shrink: true }}
                        type="date"
                        value={dateEnd}
                        onChange={(e) => setDateEnd(e.target.value)}
                        variant="outlined"
                        size="small"
                        sx={{
                            "& .MuiOutlinedInput-root": { 
                                borderRadius: "12px",
                                backgroundColor: alpha(theme.palette.background.default, 0.5)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        startIcon={<FilterList />}
                        onClick={() => {
                            setDateStartTicket(dateStart);
                            setDateEndTicket(dateEnd);
                            setFetchDataFilter(!fetchDataFilter);
                            fetchData(!fetchDataFilter);
                        }}
                        sx={{
                            borderRadius: "50px",
                            height: '40px',
                            textTransform: 'none',
                            fontWeight: 'bold',
                            boxShadow: "none",
                            "&:hover": {
                                boxShadow: theme.shadows[2]
                            }
                        }}
                    >
                        Filtrar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Filters;
